export const SET_ERROR_CODE = 'SET_ERROR_CODE';
export const CLEAN_ERROR_CODE = 'CLEAN_ERROR_CODE';

export function setErrorCode(payload) {
  const { errorCode } = payload;
  return {
    type: SET_ERROR_CODE,
    payload: { errorCode }
  };
}

export function clearErrorCode(payload) {
  const { errorCode } = payload;
  return {
    type: CLEAN_ERROR_CODE,
    payload: { errorCode }
  };
}
